import Toast from "bootstrap/js/dist/toast";

export function initToasts(root = document) {
    root.querySelectorAll(".app-toast-container .toast").forEach((element) => {
        Toast.getOrCreateInstance(element).show();
    });
}
